import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  constructor(private logger: NGXLogger) {}

  trace(message: string, ...additional: any[]): void {
    this.logger.trace(message, ...additional);
  }

  debug(message: string, ...additional: any[]): void {
    this.logger.debug(message, ...additional);
  }

  info(message: string, ...additional: any[]): void {
    this.logger.info(message, ...additional);
  }

  warn(message: string, ...additional: any[]): void {
    this.logger.warn(message, ...additional);
  }

  error(message: string, ...additional: any[]): void {
    this.logger.error(message, ...additional);
  }

  fatal(message: string, ...additional: any[]): void {
    this.logger.fatal(message, ...additional);
  }
}
